import { createLogger } from '@lsk4/log';

export const log = createLogger('creds');
